import _ from 'lodash';
import {
  useState,
  useEffect,
} from 'react';
import {
  qalBoxGetMediaSeriesDetails,
} from '../../services/mp-cf-api-service';

const getMediaSeriesDetails = () => {
  const [ responseData, setResponseData ] = useState({ });
  const [ updateData, setOperationData ] = useState(null);
  const {
    searchConfig,
    onOperationComplete,
  } = updateData || {};

  const getSeriesDetails = async () => {
    try {
      console.log(`QalBox searching media series details...`);
      setResponseData({
        isLoading: true,
        isError: false,
      });

      const mediaItemsApiResp = await qalBoxGetMediaSeriesDetails({
        data: searchConfig,
      });

      const responseData = _.get(mediaItemsApiResp, 'data', {});

      let errorMsg = null;
      let isError = false;

      if(responseData.success) {
        console.log('QalBox search media series details Success!!');
      } else {
        console.log('QalBox search media series details Failed!!');
        errorMsg = `Failed to search QalBox media series details.`;
        isError = true;
      }

      setResponseData({
        isLoading: false,
        isError,
        errorMsg,
        data: responseData.payload,
      });

      if(onOperationComplete) {
        onOperationComplete({
          isError,
          errorMsg,
          data: responseData.payload,
        });
      }
    } catch (err) {
      console.log('Something went wrong while searching QalBox media series details. ', err);
      const errorMsg = `Error occurred while searching QalBox media series details.`;
      setResponseData({
        isLoading: false,
        isError: true,
        errorMsg,
        data: null,
      });
      if(onOperationComplete) {
        onOperationComplete({
          isError: true,
          errorMsg,
          data: null,
        });
      }
    }
  };

  useEffect( () => {
    if(!_.isEmpty(updateData)) {
      getSeriesDetails();
    }
  }, [ updateData ]);

  return [
    responseData,
    setOperationData,
  ];
};

export default getMediaSeriesDetails;
